import { PositionTransferLotsAdapter } from '../../components/experience/forms/PositionTransferLotsAdapter';
import { registerFieldAdapter } from './field-adapters';
import { registerPayloadBuilder } from './payload-builder-registry';
import { registerPayloadSchema } from './payload-schema-registry';

registerFieldAdapter({ fieldType: 'positionTransferLots', component: PositionTransferLotsAdapter });

registerPayloadSchema({
  id: '#/schemas/command.positionTransfers.request',
  allowedKeys: ['sourcePortfolioAccountId', 'destinationPortfolioAccountId', 'instrumentSymbol', 'businessReference', 'reason', 'allocations'],
  requiredKeys: ['sourcePortfolioAccountId', 'destinationPortfolioAccountId', 'instrumentSymbol', 'businessReference', 'reason', 'allocations'],
});
registerPayloadSchema({
  id: '#/schemas/command.positionTransfers.decision',
  allowedKeys: ['id', 'expectedVersion', 'reason'],
  requiredKeys: ['id', 'expectedVersion'],
});
registerPayloadBuilder({
  id: 'builder.positionTransfer.request' as never,
  buildWithProvenance: values => {
    const plan = values.allocationPlan as { destinationPortfolioAccountId?: unknown; allocations?: unknown } | undefined;
    return {
      payload: {
        sourcePortfolioAccountId: String(values.sourcePortfolioAccountId ?? '').trim(),
        destinationPortfolioAccountId: String(plan?.destinationPortfolioAccountId ?? '').trim(),
        instrumentSymbol: String(values.instrumentSymbol ?? '').trim(),
        businessReference: String(values.businessReference ?? '').trim(),
        reason: String(values.reason ?? '').trim(),
        allocations: Array.isArray(plan?.allocations) ? plan.allocations : [],
      },
      provenance: {
        sourcePortfolioAccountId: ['sourcePortfolioAccountId'],
        destinationPortfolioAccountId: ['allocationPlan'], instrumentSymbol: ['instrumentSymbol'],
        businessReference: ['businessReference'], reason: ['reason'], allocations: ['allocationPlan'],
      },
    };
  },
  fieldBindings: {
    sourcePortfolioAccountId: { sourceFields: ['sourcePortfolioAccountId'] },
    destinationPortfolioAccountId: { sourceFields: ['allocationPlan'] },
    instrumentSymbol: { sourceFields: ['instrumentSymbol'] }, businessReference: { sourceFields: ['businessReference'] },
    reason: { sourceFields: ['reason'] }, allocations: { sourceFields: ['allocationPlan'] },
  },
});
